<template>
  <div class="wrapper">
    <div class="shop-container">
      <div class="nav">
        <router-link to="home">{{$t('home')}}</router-link>
        <span>></span>
        <span>Instruction Manual</span>
      </div>
      <div class="main" v-loading="loading">
        <div class="l bgw">
          <h6>Instruction Manual</h6>
          <div class="list-wrap" v-for="(item,index) in list" :key="index" @click="typeCLick(item)">
            <div class="classify">
              <img src="http://www.sanlida.cn/templates/pccommon/images/new/article_12.jpg" alt="">
              <h3 class="title">{{item.type_name}}</h3>
            </div>
            <ul>
              <li v-for="(nav,i) in item.child" :key="i" :class="{'active':artClassId==nav.id}">
                <a href="javascript:;" @click="lookType(nav)">{{nav.type_name}}</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="r">
          <div class="bgw">
            <template v-if="showDetail">
              <!-- <div class="article-nav">
                <div v-for="(item,index) in detail.article_type" :key="index">
                  <div v-for="(father,key) in item.father" :key="key">
                    <span class="artlink">{{father.type_name}}</span> >
                    <a href="javascript:;" class="artlink" @click="getArticleList(item.id)">{{item.type_name}}</a>
                  </div>
                </div>
              </div> -->
              <div class="top-head">
                {{detail.title}}
                <div class="info">
                  <span>
                    <!-- {{detail.ctime}} -->
                  </span>
                </div>
              </div>
              <template>
                <div v-html="detail.content" style="line-height:20px;"></div>
              </template>
            </template>
            <template v-else>
              <ul class="art-list">
                <li v-for="(item,index) in articleList" :key="index">
                  <div class="media">
                    <div class="media-body">
                      <a href="javascript:;" @click="getArticleDetail(item.id)">
                        <h4>{{item.title}}</h4>
                      </a>
                      <div class="info">
                        <span>  {{newTime(item.ctime)}} </span>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
              <Pagination :totalPage="totalPage" :limit="limit" @changePage="handOrderMore" v-if="totalPage>1"></Pagination>
            </template>
          </div>
          <div style="" class="next-article">
            <div class="up" v-if="detail.up && detail.up.id" @click="changeId(detail.up.id)">
              {{$t('previous')}}: <span>{{detail.up.title}}</span>
            </div>
            <div class="next"  v-if="detail.down && detail.down.id"  @click="changeId(detail.down.id)">
              {{$t('nextArticle')}}: <span>{{detail.down.title}}</span>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/common/Pagination.vue'
export default {
  name: 'Center',
  components: { Pagination },
  inject: ['reload'],
  props: {},
  data() {
    return {
      list: [],
      page: 1,
      limit: 10,
      articleList: [],
      detail: {},
      totalPage: 0,
      showDetail: false,
      artClassId: '',
      hotList: [],
      artId: 0,
      loading: false
    }
  },
  watch: {
    $route(to, from) {
      this.changeId(to.query.article_id)
    }
  },
  computed: {
    newTime() {
      return time => {
        let ctime = time.split(' ')
        return ctime[0]
      }
    }
  },
  methods: {

    typeCLick(val) {
      console.log(val)
      this.$router.replace({
        path: '/books',
        query: {
          id: val.id
        }
      })
    },
    changeId(id) {
      this.$router.replace({
        path: '/bookdetail',
        query: {
          id: id
        }
      })
      this.reload()
    },
    lookType(nav) {
      this.$router.replace({
        path: '/help',
        query: {
          article_id: nav.id
        }
      })
      this.reload()
      // this.artClassId = nav.id
      // this.getArticleList(nav.id)
    },
    handOrderMore(val) {  
      this.page = val
      this.getArticleList(this.artId)
    },
    //获取分类列表
    getArticleList(id) {
      let data = {
        type_id: id || this.artClassId,
        page: this.page,
        limit: this.limit
      }
      this.$router.replace({
        path: '/help',
        query: {
          type_id: id
        }
      })
      this.$api.articleList(data).then(res => {
        if (res.status) {
          this.articleList = res.data.list
          this.totalPage = Math.ceil(
            Number(res.data.count) / Number(this.limit)
          )
          this.showDetail = false
        }
      })
    },
    //获取文章详情
    getArticleDetail(id) {
      this.loading = true
      let data = {
        article_id: id
      }
      this.$api.manualsGetArticleDetail(data).then(res => {
        setTimeout(() =>{
          this.loading = false
        }, 500)
        if (res.status) {
          this.detail = res.data
          this.artClassId = res.data.article_type[0].id
          this.showDetail = true
          // this.$router.replace({
          //   path: '/help',
          //   query: {
          //     article_id: id
          //   }
          // })
        } else {
          this.$msg(res.msg, 'error')
        }
      })
    },
    // 获取文章所有分类
    getArticleNav() {
      this.$api.manualsGetList().then(res => {
        if (res.status) {
          this.list = res.data.list
        }
      })
    },
    // 获取推荐
    getRecommend() {
      this.$api.articleRecommend().then(res => {
        if (res.status) {
          this.hotList = res.data.hot
        }
      })
    }
  },
  created() {},
  mounted() {
    let query = this.$route.query
    this.getArticleNav()
    this.getArticleDetail(query.id)
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/mixin.scss';
@import '@/assets/css/variable.scss';
.next-article {
  background: #fff; 
  padding: 20px;
  font-size: 14px;
  overflow: hidden;
  span {
    cursor: pointer;
    color: #e7442f;
    font-size: 12px;
  }
  .up {
    float: left;
  }
  .next {
    float: right;
  }
}
.wrapper {
  .nav {
    @include line-height(40px);
    font-size: 12px;
    span {
      padding: 0 4px;
      font-size: #757575;
    }
    a:hover {
      color: #000;
    }
  }
  .main {
    display: flex;
    margin-bottom: 20px;
    flex-direction: row-reverse;
    .l {
      width: 234px;
      margin-left: 20px;
      // padding: 40px 0;
      h6 {
        width: 175px;
        color: #e7442f;
        border-bottom: 1px solid #f0f0f0;
        font-weight: normal;
        font-size: 18px;
        height: 45px;
        overflow: hidden;
        padding-left: 25px;
        line-height: 47px;
        background: #fff url('http://www.sanlida.cn/templates/pccommon/images/new/article_03.jpg') no-repeat 20px 16px;
      }
      .article {
        padding-left: 20px;
        img {
          height: 20px;
          vertical-align: bottom;
        }
        h2 {
          font-size: 17px;
          display: inline-block;
        }
      }

      .list-wrap {
        // margin-bottom: 20px;
        cursor: pointer;
        .classify {
          padding-left: 30px;
          img {
            width: 4px;
            vertical-align: middle;
            margin-right: 8px;
          }
          .title {
            display: inline-block;
            height: 40px;
            line-height: 40px;
            font-size: 16px;
            color: #333;
          }
        }

        ul {
          padding-left: 20px;
          li {
            padding-left: 48px;
            height: 32px;
            line-height: 32px;
            color: #757575;
            cursor: pointer;
            &.active {
              color: $theme-color;
            }
            a:hover {
              color: $theme-color;
            }
            a.router-link-active {
              color: $theme-color;
            }
          }
        }
      }
      .xian {
        border-top: 1px solid #ccc;
        width: 190px;
        text-align: center;
        margin-left: 25px;
        margin-bottom: 20px;
      }
      .recommend {
        padding: 10px;
        .title {
          // font-size: 17px;
          // color: #555;
          img {
            height: 20px;
            vertical-align: bottom;
          }
          h2 {
            font-size: 17px;
            display: inline-block;
          }
        }
        .reList {
          margin-top: 10px;
          list-style: none;
          color: rgb(85, 85, 85);
          border: 1px solid #e4eaec;
          border-radius: 4px;
          cursor: pointer;
          .reItem {
            padding: 10px 10px 10px 15px;
            white-space: normal;
            word-break: break-all;
            word-wrap: break-word;
            display: flex;
            .recommendTitle {
              display: flex;
              flex-direction: column;
              justify-content: space-between;
            }
            img {
              width: 20px;
              vertical-align: middle;
            }
            span {
             
              line-height: 20px;
            }
            .title {
              white-space: nowrap;
              overflow:hidden; 
              text-overflow:ellipsis;
              // display:-webkit-box; 
              // -webkit-box-orient:vertical;
              // -webkit-line-clamp:2;
            }
          }
        }
      }
    }
    .r {
      flex: 1;
      .bgw {
        padding: 24px;
        min-height: 600px;
        .article-nav {
          height: 30px;
          line-height: 30px;
          border-bottom: 1px dashed $border;
          margin-bottom: 20px;
          a.artlink {
            &:hover {
              color: $theme-color;
            }
          }
        }
        .top-head {
          font-size: 24px;
          font-weight: 400;
          line-height: 40px;
          color: #757575;
          margin-bottom: 10px;
          border-bottom: 1px solid rgb(238, 238, 238);
          .info {
            font-size: 14px;
            color: #76838f;
            span {
              margin-right: 10px;
              img {
                width: 15px;
                vertical-align: middle;
              }
            }
          }
        }
      }
      .art-list {
        li {
          padding: 20px 10px;
          border-bottom: 1px solid rgb(238, 238, 238);
          a {
            display: block;
            // padding: 10px;
            cursor: pointer;
            &:hover {
              color: $theme-color;
            }
          }
          .media {
            .media-left {
              width: 100px;
              height: 100px;
              display: inline-block;
              padding-right: 20px;
              vertical-align: top;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .media-body {
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: space-between;
              h4 {
                color: #333333;
                // margin-bottom: 20px;
                font-size: 16px;
              }
              .des {
                font-size: 14px;
                margin-bottom: 20px;
                color: #76838f;
                line-height: 20px;
              }
              .info {
                font-size: 14px;
                color: #76838f;
                span {
                  margin-right: 10px;
                  img {
                    width: 15px;
                    vertical-align: middle;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
.recommendCover {
  display: inline-block;
  width: 50px;
  height: 50px;
  vertical-align: top;
  img {
    width: 50px !important;
  }
}
.recommendTitle {
  display: inline-block;
  width: 131px;
  margin-left: 5px;
}
</style>
